import React from "react";
import { SearchDropdownManager } from "../../hooks/useSearchDropdown";
import Resources from "../../types/Resources";

type SearchDropdownProps<TSearchType> = {
    inputId: string;
    handler: SearchDropdownManager<TSearchType>;
    noSearchResultsText: string | undefined;
    searchLabel: string | undefined;
    placeHolder?: string;
};

const SearchDropdown = React.forwardRef<HTMLDivElement, SearchDropdownProps<any>>(
    <TSearchType,>(
        {
            handler,
            noSearchResultsText,
            searchLabel,
            inputId,
            placeHolder = ""
        }: SearchDropdownProps<TSearchType>,
        ref: React.Ref<HTMLDivElement>
    ) => {
        const searchResultListItems = handler.searchResults.map((r) => (
            <li
                key={r.id}
                onClick={() => handler.searchResultClickHandler(r)}
                className="list-group-item p-2 border-top"
            >
                {r.text}
            </li>
        ));

        return (
            <div className="mt-3" ref={ref}>
                <label htmlFor={inputId}>{searchLabel}</label>
                <input
                    id={inputId}
                    placeholder={placeHolder}
                    type="text"
                    className="form-control"
                    value={handler.searchInput ?? ""}
                    onChange={(e) => handler.searchInputChangeHandler(e.target.value)}
                />
                <div
                    id="diving-permit-search-results"
                    className="list-group work-permit-search-results"
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                    {!handler.searchResultDropdownIsOpen ? null : handler.searchResults.length === 0 ? (
                        <div>{noSearchResultsText}</div>
                    ) : (
                        <ul className="list-unstyled search-results border rounded">{searchResultListItems}</ul>
                    )}
                </div>
            </div>
        );
    }
);

export default SearchDropdown;
